import type { CliplisterViewerConfig } from './types';

export const defaultPlayerConfig: CliplisterViewerConfig = {
  parentId: '',
  customer: '',
  assetKeys: [''],
  keyType: 10000,
  stage: {
    width: '100%',
    aspectRatio: 'asset',
  },
  plugins: {
    ClickableVideo: {
      layer: 1,
    },
    InnerControls: {
      layer: 2,
      id: 'controls',
      blacklist: ['share', 'quality', 'playback-speed'],
      template: {
        type: 'external',
        source: 'https://mycliplister.com/static/viewer/assets/skins/default/controls.html',
      },
    },
    BufferingSpinner: {
      layer: 3,
      width: 50,
      height: 50,
    },
    PreviewImage: {
      layer: 4,
    },
    PlayButton: {
      id: 'playButton',
      layer: 5,
      image: 'https://mycliplister.com/static/viewer/assets/skins/default/playButton.png',
      width: 100,
      height: 100,
    },
    NextButton: {
      layer: 6,
      timeAfterStart: 10,
      timeTillEnd: 10,
      visibility: 'mouseover',
      template: 'https://mycliplister.com/./static/viewer/assets/skins/empiriecom/next-button.html',
      position: {
        top: 8,
        right: 8,
      },
    },
    AutoplayNext: {
      layer: 7,
      wait: 5,
    },
  },
};
